import { Text, TextField, ContextualSaveBar, Card, InlineStack, BlockStack, Divider, Icon } from '@shopify/polaris'
import React, { useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../../Core';
import useContextualSaveBar, { isAdminLoggedIn } from '../../../Panel/index';
import { getLastSyncInformation } from '../../ConfigHelper';
import { RefreshMajor } from '@shopify/polaris-icons';
import { RenderSkeletonGlobalPrice } from '../../skeleton/skeleton';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

function GlobalPriceAdjustment(Props: Props) {
    const { t } = useTranslation();
    const [saveLoader, setSaveLoader] = useState<boolean>(false);
    const [showSkeleton, setShowSkeleton] = useState<boolean>(true);
    const [configData, setconfigData] = useState<any>({
        "source_currency": Props?.redux?.current?.source?.currency,
        "source_value": "1",
        "target_currency": Props?.redux?.current?.target?.currency,
        "target_value": 0
    });
    const [targetValueError, settargetValueError] = useState<boolean>(false);
    const [showContextualSaveBar, setShowContextualSaveBar] = useState<boolean>(false);
    const { showSaveBar, hideSaveBar } = useContextualSaveBar(Props);
    const [initialData, setInitialData] = useState<any>({
        "source_currency": Props?.redux?.current?.source?.currency,
        "source_value": "1",
        "target_currency": Props?.redux?.current?.target?.currency,
        "target_value": 0
    });
    const [lastSync, setLastSync] = useState('')

    const getSettings = () => {
        Props.di.POST('connector/config/getConfig', {
            "group_code": ["currency"]
        }).then((response: any) => {
            setShowSkeleton(false);
            if (response?.success) {
                let settings = response?.data?.[0]?.value;
                let tempSettings = JSON.parse(JSON.stringify(configData))
                tempSettings['source_value'] = settings['source_value'] ?? '1';
                tempSettings['target_value'] = settings['target_value'] ?? 0;
                setInitialData({ ...tempSettings });
                setconfigData({ ...tempSettings });
            }
            else { //front end se api call mein agar koi error hogi
                Props.error(t(response?.message) ?? t("Oops! Some error occured while getting data."));
            }
        });
    }

    const getLastGlobalPriceSyncDate = () => {
        let data = getLastSyncInformation(Props, 'currency');
        data.then((res: any) => {
            if (res?.error) Props.error(t(res?.error) ?? '');
            else setLastSync(res?.date ?? '')
        })
    }

    useEffect(() => {
        getSettings();
        getLastGlobalPriceSyncDate();
    }, []);

    useEffect(() => {
        if (Object.keys(configData)?.length > 0) {
            if (JSON.stringify(initialData) != JSON.stringify(configData)) setShowContextualSaveBar(true);
            else setShowContextualSaveBar(false);
        }
    }, [configData]);

    const handleDiscardBtn = () => {
        setShowSkeleton(true);
        setconfigData({
            "source_currency": Props?.redux?.current?.source?.currency,
            "source_value": "1",
            "target_currency": Props?.redux?.current?.target?.currency,
            "target_value": 0
        });
        settargetValueError(false);
        getSettings();
        getLastGlobalPriceSyncDate();
    }

    const getPreparedData = () => {
        return ([
            {
                "data": {
                    source_currency: configData?.source_currency,
                    source_value: configData?.source_value,
                    target_currency: configData?.target_currency,
                    target_value: configData?.target_value
                },
                "group_code": "currency"
            }
        ])
    }

    const hanldeSaveClick = () => {
        setSaveLoader(true);
        if (configData?.target_value == "" || configData?.target_value <= "0") {
            Props.error(t("Kindly fill valid value in amazon price multiplier."))
            setSaveLoader(false);
            settargetValueError(true);
        }
        else {
            let preparedData = getPreparedData();
            Props.di.POST("connector/profile/saveDefaultSettings", {
                type: "amazon",
                marketplace: "amazon",
                data: preparedData
            }).then((response: any) => {
                setSaveLoader(false)
                if (response?.success) {
                    Props?.success(response?.message ?? t("Settings saved successfully."));
                    getSettings();
                    getLastGlobalPriceSyncDate();
                }
                else { Props?.error(response?.message ?? t("Oops! some error occured.")) }
            })
        }
    }

    //Contextual Save Bar of App Bridge
    if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) {
        let savebar_options: any = {
            loading: saveLoader,
        };
        if (showContextualSaveBar) {
            showSaveBar(handleDiscardBtn, hanldeSaveClick, { ...savebar_options });
        } else hideSaveBar();
    }

    const handleInputChange = ((key: string, value: string) => {
        if (key == "amazon") {
            configData['target_value'] = value
        }
        else {
            configData['source_value'] = value
        }
        setconfigData({ ...configData });
    })


    const renderSettings = () => {
        if (configData !== undefined) {
            return <>
                {showContextualSaveBar && (process.env.REACT_APP_PROD === "0" ||
                    isAdminLoggedIn()) && (
                        <ContextualSaveBar
                            message={t("Unsaved changes")}
                            saveAction={{
                                onAction: () => hanldeSaveClick(),
                                loading: saveLoader,
                                disabled: false,
                            }}
                            discardAction={{
                                onAction: () => { handleDiscardBtn() },
                            }}
                        />
                    )}
                <BlockStack gap="500">
                    <BlockStack gap="100">
                        <Text variant="headingMd" as="h6">{t("Global Price Adjustment")}</ Text>
                        <Text as="p" fontWeight="regular" tone='subdued'>
                            {t("The feature works as a Global Currency Converter that allows sellers to upload Products in different Currencies as per their need by converting prices from the native Shopify Product Currency into the target Amazon Account’s Currency. For example, if your Shopify account is from the US and your Products prices are in US dollars, then you can easily upload Products in Rupees on Amazon.in by employing the Global Currency Convertor.")}
                        </Text>
                    </BlockStack>
                    <Card roundedAbove='sm'>
                        <InlineStack gap="200">
                            <div className='Custom-Stack-Item--fill'>
                                <TextField
                                    prefix={configData?.source_currency}
                                    value={configData?.source_value + ""}
                                    label={t('Shopify Store Currency')}
                                    autoComplete='off'
                                    onChange={(e) => { handleInputChange("shopify", e) }}
                                    disabled
                                    type='number' />
                            </div>
                            <div className='Custom-Stack-Item--fill'>
                                <TextField
                                    prefix={configData?.target_currency}
                                    value={configData?.target_value + ""}
                                    label={t("Amazon Price Multiplier")}
                                    autoComplete='off'
                                    onChange={(e) => {
                                        if (e.indexOf(".") == -1) {
                                            handleInputChange("amazon", e);
                                            settargetValueError(e == "" || e <= "0")
                                        } else if (e.indexOf(".") > 0 && (e.indexOf('.') + 6 >= e.length)) {
                                            handleInputChange("amazon", e);
                                            settargetValueError(e == "" || e <= "0")
                                        }
                                    }}
                                    type='number'
                                    error={targetValueError}
                                    requiredIndicator
                                />
                            </div>
                        </InlineStack>
                    </Card>

                    {lastSync && <>
                        <Divider />

                        <InlineStack blockAlign='center' align='space-between' gap="200">
                            <div className='Custom__Sync--Update'>
                                <InlineStack gap="200" wrap={false}>
                                    <div>
                                        <Icon source={RefreshMajor} tone="base" />
                                    </div>
                                    <Text variant="headingSm" as="h6" tone='subdued'>
                                        {t("Last updated:")} {lastSync}
                                    </Text>
                                </InlineStack>
                            </div>
                        </InlineStack>
                    </>}
                </BlockStack>
            </>;
        }
    }
    return (
        <>
            {showSkeleton ? RenderSkeletonGlobalPrice() : renderSettings()}
        </>
    )
}

export default DI(GlobalPriceAdjustment)